<script>
    export let color = 'fff'
    export let fsize = '3'
</script>

<color-box>
    <color-swatch style="background-color: #{color}">&nbsp;</color-swatch>
    <color-hex style="font-size: {fsize}vw">{color}</color-hex>
</color-box>

<style>
    color-box {
        display: flex;
        flex: 1;
        flex-direction: column;
    }
    color-swatch {
        display: flex;
        flex: 1;
        margin-bottom: auto;
    }
    color-hex {
        font-family: 'Inconsolata', monospace;
        color: #737373;
        display: flex;
        padding: 1vh;
        margin-top: auto;
        justify-content: center;
        align-items: center;
    }
</style>